import { createFileRoute } from "@tanstack/react-router";
import BuilderPortalLayout from "lib/components/builders/BuilderPortalLayout";
import withAuthentication from "../../../../components/withAuthentication";

/** @todo Use this page as the entry point for the estimation jobs dashboard */
function TasksPage() {
  return (
    <BuilderPortalLayout header="All Tasks" pageTitle="Task Details">
      <div>Tasks (In Progress)</div>
    </BuilderPortalLayout>
  );
}

export const Route = createFileRoute("/builders/$builder_id/tasks/")({
  component: withAuthentication(TasksPage, { features: ["estimationTasks"] }),
});
